module.exports = ".panel h3 {\n  text-transform: none; }\n\n@media only screen and (min-width: 40.0625em) {\n  .panel {\n    padding: 4.375rem; } }\n"